import { HelpDrawer, Portal } from '@common/overlay-manager';

import { RecommendTooltipView } from './RecommendTooltipView';

export interface RecommendTooltipProps {
  open: boolean;
  onClose: () => void;
  isOptionType: boolean;
}

export const RecommendTooltip: React.FC<React.PropsWithChildren<RecommendTooltipProps>> = ({
  open,
  onClose,
  isOptionType,
}) => {
  return (
    <Portal>
      <HelpDrawer title='사이즈 추천' open={open} onClose={onClose}>
        <RecommendTooltipView isOptionType={isOptionType} />
      </HelpDrawer>
    </Portal>
  );
};
